<template>
    <app-layout content_class="has-background-light">
        <div class="is-clearfix">
            <h1 class="title is-pulled-left">Account Settings</h1>
            <user-avatar class="is-pulled-right"/>
        </div><br/>

        <div class="columns">
            <div class="column is-6">
                <div class="box">
                    <user-update-form/>
                </div>
            </div>

            <div class="column is-6">
                <div class="box fullheight">
                    <user-change-password/>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-6">
                <div class="box">
                    <user-change-avatar/>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '../components/layouts/AppLayout.vue';
import UserAvatar from '../components/user/UserAvatar.vue';
import UserUpdateForm from '../components/user/UserUpdateForm.vue';
import UserChangePassword from '../components/user/UserChangePassword.vue';
import UserChangeAvatar from '../components/user/UserChangeAvatar.vue';

export default {
    name: 'Settings',
    components: {
        UserChangeAvatar, UserChangePassword, UserUpdateForm, UserAvatar, AppLayout,
    },
};
</script>

<style scoped>
    .fullheight {
        height: 100%;
    }
</style>
